import {
  combineReducers,
  configureStore,
  applyMiddleware,
} from "@reduxjs/toolkit";
import ErrorReducer from "./error/ErrorSlice";
import LoadingReducer from "./loading/LoadingSlice";
import DataReducer from "./data/DataSlice";
import ModalReducer from "./modal/ModalSlice";
import userReducer from "./user/UserSlice";

// configuration of session persist
import sessionStorage from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import logger from "redux-logger";

const middlewares = [];
if (process.env.REACT_APP_NODE_ENV === "development") {
  //this for display logger in console when we are developping
  middlewares.push(logger);
}

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  whitelist: ["user"],
};
const rootReducer = combineReducers({
  error: ErrorReducer,
  loading: LoadingReducer,
  data: DataReducer,
  modal: ModalReducer,
  user: userReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== "production",
  middleware: [thunk],
});

export const persistor = persistStore(store);
